import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { FormLayout } from '../components/Layout/FormLayout';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button/Button';
import { addCar, updateCar } from '../store/carSlice';

export default function CarFormPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const cars = useSelector(state => state.cars);
  
  const isEditing = Boolean(id);
  const existingCar = isEditing ? cars.find(car => car.id === id) : null;

  const [form, setForm] = useState({
    make: '',
    model: '',
    year: '',
    plate: '',
    status: 'Available',
  });

  useEffect(() => {
    if (isEditing && existingCar) {
      setForm({
        make: existingCar.make,
        model: existingCar.model,
        year: existingCar.year,
        plate: existingCar.plate,
        status: existingCar.status,
      });
    }
  }, [isEditing, existingCar]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    
    if (isEditing) {
      dispatch(updateCar({ id, ...form }));
    } else {
      dispatch(addCar(form));
    }
    
    // Navigate back to cars list
    navigate('/cars');
  };

  const handleCancel = () => {
    navigate('/cars');
  };

  return (
    
    <FormLayout
      title={isEditing ? "Edit Car" : "Add New Car"}
      description="Fill in the car details below"
      onSubmit={handleSubmit}
      footer={
        <>
          <Button variant="outline" type="button" onClick={handleCancel}>Cancel</Button>
          <Button type="submit">{isEditing ? "Update" : "Save"}</Button>
        </>
      }
    >
      <Input
        name="make"
        label="Make"
        value={form.make}
        onChange={handleChange}
        placeholder="e.g. Toyota"
        required
      />
      <Input
        name="model"
        label="Model"
        value={form.model}
        onChange={handleChange}
        placeholder="e.g. Corolla"
        required
      />
      <Input
        name="year"
        label="Year"
        type="number"
        value={form.year}
        onChange={handleChange}
        placeholder="e.g. 2023"
        required
      />
      <Input
        name="plate"
        label="Plate"
        value={form.plate}
        onChange={handleChange}
        placeholder="e.g. KL-07-BN-1234"
        required
      />
      <div className="md:col-span-2">
        <label className="block mb-1 font-medium text-[var(--text-secondary)]">Status</label>
        <select
          name="status"
          value={form.status}
          onChange={handleChange}
          className="w-full px-4 py-2 rounded-md border border-[var(--input-border)] bg-[var(--input-bg)] text-[var(--input-text)] focus:ring-2 focus:ring-[var(--border-focus)]"
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>
    </FormLayout>
  );
}
